<template>
    <div>
        <v-card-text>
            <!-- Filtros -->
            <v-row dense align="center">
                <v-col cols="12" sm="6" md="2">
                    <v-select v-model="filtros.tipo" :items="tipos" item-text="texto" item-value="valor" label="Tipo" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                    <v-select v-model="filtros.activo" :items="ESTADOS" label="Estado" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="6" sm="3" md="1">
                    <v-select v-model="filtros.anyo" :items="opciones.anyos" label="Año" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="6" sm="3" md="1">
                    <v-select v-model="filtros.promocion" :items="opciones.promociones" label="Promoción" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-autocomplete v-model="filtros.importacion_id" :items="opciones.importaciones" item-text="texto" item-value="id" label="Importación" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="6" sm="3" md="1">
                    <v-text-field v-model="filtros.registro_desde" label="Reg. desde" type="number" min="0" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="6" sm="3" md="1">
                    <v-text-field v-model="filtros.registro_hasta" label="Reg. hasta" type="number" min="0" outlined dense hide-details clearable/>
                </v-col>
                <v-col cols="12" md="1" class="text-md-right d-flex justify-end">
                    <v-btn color="info" small outlined class="mr-2" :loading="cargando" title="Aplicar filtros y actualizar" @click="cargar">
                        <v-icon small>refresh</v-icon>
                    </v-btn>
                    <v-btn color="success" small outlined v-if="permisos.crear" @click="nuevo">
                        <v-icon small left>add</v-icon> Nuevo
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table
                dense
                class="mt-4"
                :headers="encabezados"
                :items="filas"
                :loading="cargando"
                item-key="video_id"
                :items-per-page="15"
                :footer-props="$store.state.footerPropsTable"
            >
                <template v-slot:[`item.titulo`]="{ item }">
                    <div class="font-weight-medium">{{ item.titulo }}</div>
                    <div class="text-caption grey--text">
                        {{ item.fuente_texto }}<template v-if="item.archivo_nombre"> · {{ item.archivo_nombre }}</template><template v-if="item.youtube_id"> · {{ item.youtube_id }}</template>
                    </div>
                </template>
                <template v-slot:[`item.tipo_texto`]="{ item }">
                    <v-chip x-small label outlined :color="COLORES_TIPO[item.tipo] || 'grey'">{{ item.tipo_texto }}</v-chip>
                </template>
                <template v-slot:[`item.alcance_texto`]="{ item }">
                    <span :class="item.alcance_texto === 'Todos los participantes' ? 'grey--text' : ''">{{ item.alcance_texto }}</span>
                </template>
                <template v-slot:[`item.vigencia`]="{ item }">
                    <template v-if="item.fecha_desde || item.fecha_hasta">
                        {{ fechaCorta(item.fecha_desde, 'Sin inicio') }} – {{ fechaCorta(item.fecha_hasta, 'Sin fin') }}
                    </template>
                    <span v-else class="grey--text">Sin límite</span>
                    <div class="text-caption grey--text" v-if="item.tipo === 'promocional'">
                        {{ item.disparador_texto }}<template v-if="item.disparador === 'recurrencia'"> ({{ item.recurrencia_dias }} días)</template>
                    </div>
                </template>
                <template v-slot:[`item.activo`]="{ item }">
                    <v-chip x-small label :color="item.activo ? (item.vigente ? 'success' : 'warning') : 'grey'" text-color="white"
                            :title="item.activo && !item.vigente ? (item.disponible ? 'Activo pero fuera de su rango de fechas' : 'Activo pero sin archivo disponible') : ''">
                        {{ item.activo ? (item.vigente ? 'Vigente' : 'Activo, no vigente') : 'Inactivo' }}
                    </v-chip>
                </template>
                <template v-slot:[`item.fecha_crea`]="{ item }">
                    {{ (item.fecha_actualiza || item.fecha_crea) | fechaESPHora }}
                    <div class="text-caption grey--text" v-if="item.registrado_por">por {{ item.registrado_por }}</div>
                </template>
                <template v-slot:[`item.acciones`]="{ item }">
                    <v-btn icon small color="primary" title="Ver video" :disabled="!item.disponible" @click="previsualizar(item)"><v-icon small>play_circle</v-icon></v-btn>
                    <v-btn icon small color="info" v-if="permisos.editar" title="Editar" @click="editar(item)"><v-icon small>edit</v-icon></v-btn>
                    <v-btn icon small :color="item.activo ? 'warning' : 'success'" v-if="permisos.editar" :title="item.activo ? 'Desactivar' : 'Activar'" @click="activar(item)">
                        <v-icon small>{{ item.activo ? 'pause_circle' : 'check_circle' }}</v-icon>
                    </v-btn>
                    <v-btn icon small color="error" v-if="permisos.eliminar" title="Eliminar" @click="confirmarEliminar(item)"><v-icon small>delete</v-icon></v-btn>
                </template>
                <template v-slot:no-data>
                    <v-alert dense type="info" outlined class="text-center mt-3">
                        No hay videos con esos filtros. {{ permisos.crear ? 'Use el botón Nuevo para agregar el primero.' : '' }}
                    </v-alert>
                </template>
            </v-data-table>
        </v-card-text>

        <!-- Formulario -->
        <v-dialog v-model="dialogo" max-width="820" persistent scrollable>
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    {{ modelo.video_id ? 'Editar' : 'Nuevo' }} video
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialogo = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valido" @submit.prevent="guardar">
                        <v-row dense>
                            <v-col cols="12" md="7">
                                <v-text-field v-model="modelo.titulo" label="Título" outlined dense maxlength="150" counter="150" :rules="[reglas.requerido]"
                                              placeholder="Ej. Mensaje de la Dirección Ejecutiva"/>
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-select v-model="modelo.tipo" :items="tipos" item-text="texto" item-value="valor" label="Tipo de video" outlined dense :rules="[reglas.requerido]"
                                          :hint="AYUDA_TIPO[modelo.tipo]" persistent-hint/>
                            </v-col>

                            <v-col cols="12">
                                <v-radio-group v-model="modelo.fuente" row dense hide-details class="mt-0">
                                    <v-radio v-for="f in fuentes" :key="f.valor" :value="f.valor" :label="f.texto"/>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" v-if="modelo.fuente === 'archivo'">
                                <v-file-input v-model="archivo" outlined dense accept="video/mp4,.mp4" show-size truncate-length="48" prepend-icon="movie"
                                              :label="modelo.video_id && modelo.archivo_nombre ? `Reemplazar archivo (actual: ${modelo.archivo_nombre})` : 'Archivo MP4'"
                                              :rules="[reglas.archivo]" hint="Formato MP4, máximo 50 MB." persistent-hint/>
                            </v-col>
                            <v-col cols="12" v-else>
                                <v-text-field v-model="modelo.youtube_url" label="Enlace de YouTube" outlined dense prepend-icon="link"
                                              placeholder="https://www.youtube.com/watch?v=..." :rules="[reglas.youtube]"
                                              hint="Se acepta cualquier forma de enlace de YouTube (watch, youtu.be, embed, shorts) o el id del video." persistent-hint/>
                            </v-col>

                            <v-col cols="12" class="pt-3">
                                <div class="text-subtitle-2">Programación</div>
                                <div class="text-caption grey--text text--darken-1">Sin fechas, el video se muestra mientras esté activo.</div>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-text-field v-model="modelo.fecha_desde" label="Desde" type="date" outlined dense clearable/>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-text-field v-model="modelo.fecha_hasta" label="Hasta" type="date" outlined dense clearable :rules="[reglas.fechas]"/>
                            </v-col>
                            <template v-if="modelo.tipo === 'promocional'">
                                <v-col cols="12" md="4">
                                    <v-select v-model="modelo.disparador" :items="disparadores" item-text="texto" item-value="valor" label="Cuándo se muestra" outlined dense/>
                                </v-col>
                                <v-col cols="12" md="2" v-if="modelo.disparador === 'recurrencia'">
                                    <v-text-field v-model="modelo.recurrencia_dias" label="Cada (días)" type="number" min="1" max="365" outlined dense :rules="[reglas.recurrencia]"/>
                                </v-col>
                            </template>

                            <v-col cols="12" class="pt-3">
                                <div class="text-subtitle-2">Alcance</div>
                                <div class="text-caption grey--text text--darken-1">
                                    Deje vacío lo que no aplique: el video llega a quien cumpla todo lo indicado. Entre varios videos aplicables gana el más específico y luego el más reciente.
                                </div>
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-select v-model="modelo.anyo" :items="opciones.anyos" label="Año" outlined dense clearable/>
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-combobox v-model="modelo.promocion" :items="opciones.promociones" label="Promoción" outlined dense clearable type="number" :rules="[reglas.entero]"/>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-autocomplete v-model="modelo.importacion_id" :items="opciones.importaciones" item-text="texto" item-value="id" label="Importación" outlined dense clearable
                                                @change="rangoDeImportacion"/>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-text-field v-model="modelo.registro_desde" label="Registro desde" type="number" min="0" outlined dense clearable :rules="[reglas.entero]"/>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-text-field v-model="modelo.registro_hasta" label="Registro hasta" type="number" min="0" outlined dense clearable :rules="[reglas.entero, reglas.registros]"/>
                            </v-col>
                            <v-col cols="12" md="6" class="d-flex align-center">
                                <v-switch v-model="modelo.activo" inset hide-details color="success" class="mt-0"
                                          :label="modelo.activo ? 'Activo: se muestra a los participantes' : 'Inactivo: se conserva pero no se muestra'"/>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogo = false">Cancelar</v-btn>
                    <v-btn color="primary" depressed :loading="guardando" @click="guardar"><v-icon small left>save</v-icon> Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Vista previa -->
        <v-dialog v-model="dialogoVista" max-width="900">
            <v-card color="#0e1326" dark v-if="vista">
                <v-card-title class="text-subtitle-1 font-weight-bold py-2">
                    {{ vista.titulo }}
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialogoVista = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <!-- El reproductor solo existe mientras el diálogo está abierto. -->
                <reproductor-video v-if="dialogoVista" :video-url="vista.url" :youtube-id="vista.youtube_id" autoplay controles/>
                <v-card-actions class="px-4">
                    <span class="text-caption" style="opacity: .7">{{ vista.tipo_texto }} · {{ vista.alcance_texto }}</span>
                    <v-spacer></v-spacer>
                    <v-btn small text @click="dialogoVista = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoEliminar" max-width="440">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">Eliminar video</v-card-title>
                <v-card-text>
                    ¿Eliminar <b>{{ aEliminar ? aEliminar.titulo : '' }}</b>? Dejará de mostrarse y se borrará su archivo; las estadísticas de reproducción se conservan.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogoEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" depressed :loading="guardando" @click="eliminar">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ReproductorVideo from "@/components/Videos/ReproductorVideo.vue";
import filtros from "@/filters";

const MAXIMO_MB = 50;

export default {
    name: "VideosLista",
    components: {ReproductorVideo},
    data() {
        return {
            ESTADOS: [{text: "Activos", value: "1"}, {text: "Inactivos", value: "0"}],
            COLORES_TIPO: {predeterminado: "primary", felicitacion: "success", promocional: "secondary"},
            AYUDA_TIPO: {
                predeterminado: "Video del director: tarjeta en el inicio del participante.",
                felicitacion: "Se reproduce una sola vez por curso y persona al certificarse.",
                promocional: "Ventana emergente en el inicio según la programación.",
            },
            cargando: false,
            guardando: false,
            filas: [],
            tipos: [],
            fuentes: [],
            disparadores: [],
            opciones: {anyos: [], promociones: [], importaciones: []},
            permisos: {crear: false, editar: false, eliminar: false},
            filtros: {tipo: null, activo: null, anyo: null, promocion: null, importacion_id: null, registro_desde: null, registro_hasta: null},
            dialogo: false,
            dialogoVista: false,
            dialogoEliminar: false,
            valido: true,
            modelo: this.vacio(),
            archivo: null,
            vista: null,
            aEliminar: null,
            encabezados: [
                {text: "Video", value: "titulo"},
                {text: "Tipo", value: "tipo_texto"},
                {text: "Alcance", value: "alcance_texto", sortable: false},
                {text: "Vigencia", value: "vigencia", sortable: false},
                {text: "Estado", value: "activo", sortable: false},
                {text: "Actualizado", value: "fecha_crea"},
                {text: "", value: "acciones", sortable: false, align: "end", width: 170},
            ],
            reglas: {
                requerido: v => (v !== null && v !== undefined && String(v).trim() !== "") || "Campo requerido",
                archivo: v => {
                    if (this.modelo.video_id && this.modelo.archivo_nombre && !v) return true;
                    if (!v) return "Seleccione el archivo MP4";
                    if (v.size > MAXIMO_MB * 1024 * 1024) return `El video no puede superar ${MAXIMO_MB} MB`;
                    return true;
                },
                youtube: v => (!!v && /(youtube\.com|youtu\.be|^[A-Za-z0-9_-]{11}$)/.test(String(v).trim())) || "Pegue un enlace de YouTube válido",
                fechas: v => !v || !this.modelo.fecha_desde || v >= this.modelo.fecha_desde || "Debe ser igual o posterior a la fecha desde",
                recurrencia: v => (Number(v) >= 1 && Number(v) <= 365) || "Entre 1 y 365 días",
                entero: v => v === null || v === "" || v === undefined || (Number.isInteger(Number(v)) && Number(v) >= 0) || "Número entero",
                registros: v => !v || !this.modelo.registro_desde || Number(v) >= Number(this.modelo.registro_desde) || "Debe ser mayor o igual que registro desde",
            },
        }
    },
    methods: {
        fechaCorta(fecha, vacio) {
            return fecha ? filtros.fechaESP(fecha) : vacio;
        },
        vacio() {
            return {
                video_id: null, titulo: "", tipo: "predeterminado", fuente: "youtube", youtube_url: "", archivo_nombre: null,
                activo: true, fecha_desde: null, fecha_hasta: null, disparador: "siempre", recurrencia_dias: 7,
                anyo: null, promocion: null, importacion_id: null, registro_desde: null, registro_hasta: null,
            };
        },
        parametros() {
            const params = {};
            Object.keys(this.filtros).forEach(k => {
                const v = this.filtros[k];
                if (v !== null && v !== "" && v !== undefined) params[k] = v;
            });
            return params;
        },
        cargar() {
            this.cargando = true;
            window.axios.get("/videos", {params: this.parametros()}).then(response => {
                if (response.data.success) {
                    const d = response.data.data;
                    this.filas = d.filas;
                    this.tipos = d.tipos;
                    this.fuentes = d.fuentes;
                    this.disparadores = d.disparadores;
                    this.permisos = d.permisos;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(() => this.$toast.error("No se pudieron listar los videos."))
                .finally(() => {
                    this.cargando = false;
                });
        },
        cargarOpciones() {
            window.axios.get("/videos/opciones").then(response => {
                if (response.data.success) this.opciones = response.data.data;
            }).catch(() => this.$toast.error("No se pudieron cargar los años, promociones e importaciones."));
        },
        nuevo() {
            this.modelo = this.vacio();
            this.archivo = null;
            this.dialogo = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        editar(fila) {
            this.modelo = {
                ...this.vacio(), ...fila,
                activo: !!fila.activo,
                youtube_url: fila.youtube_id ? `https://www.youtube.com/watch?v=${fila.youtube_id}` : "",
                fecha_desde: fila.fecha_desde ? String(fila.fecha_desde).slice(0, 10) : null,
                fecha_hasta: fila.fecha_hasta ? String(fila.fecha_hasta).slice(0, 10) : null,
                recurrencia_dias: fila.recurrencia_dias || 7,
            };
            this.archivo = null;
            this.dialogo = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        /** Al elegir una importación con rango de registro, lo propone como alcance. */
        rangoDeImportacion(id) {
            const im = this.opciones.importaciones.find(i => i.id === id);
            if (im && im.registro_desde && !this.modelo.registro_desde && !this.modelo.registro_hasta) {
                this.modelo.registro_desde = im.registro_desde;
                this.modelo.registro_hasta = im.registro_hasta;
            }
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.guardando = true;
            const m = this.modelo;
            const formData = new FormData();
            formData.append("video_id", m.video_id || "");
            formData.append("titulo", m.titulo.trim());
            formData.append("tipo", m.tipo);
            formData.append("fuente", m.fuente);
            formData.append("activo", m.activo ? 1 : 0);
            if (m.fuente === "youtube") formData.append("youtube_url", String(m.youtube_url).trim());
            if (m.fuente === "archivo" && this.archivo) formData.append("archivo", this.archivo);
            if (m.tipo === "promocional") {
                formData.append("disparador", m.disparador || "siempre");
                if (m.disparador === "recurrencia") formData.append("recurrencia_dias", m.recurrencia_dias);
            }
            ["fecha_desde", "fecha_hasta", "anyo", "promocion", "importacion_id", "registro_desde", "registro_hasta"].forEach(k => {
                if (m[k] !== null && m[k] !== "" && m[k] !== undefined) formData.append(k, m[k]);
            });

            window.axios.post("/videos/guardar", formData).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.dialogo = false;
                    this.cargar();
                } else {
                    this.$toast.error(response.data.message, {timeout: 10000});
                }
            })
                .catch(error => this.$toast.error(this.mensajeDe(error, "No se pudo guardar el video."), {timeout: 10000}))
                .finally(() => {
                    this.guardando = false;
                });
        },
        activar(fila) {
            window.axios.post("/videos/activar", {video_id: fila.video_id, activo: !fila.activo}).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.cargar();
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            }).catch(error => this.$toast.error(this.mensajeDe(error, "No se pudo cambiar el estado."), {timeout: 8000}));
        },
        previsualizar(fila) {
            this.vista = fila;
            this.dialogoVista = true;
        },
        confirmarEliminar(fila) {
            this.aEliminar = fila;
            this.dialogoEliminar = true;
        },
        eliminar() {
            this.guardando = true;
            window.axios.post("/videos/eliminar", {video_id: this.aEliminar.video_id}).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.dialogoEliminar = false;
                    this.cargar();
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            })
                .catch(error => this.$toast.error(this.mensajeDe(error, "No se pudo eliminar el video."), {timeout: 8000}))
                .finally(() => {
                    this.guardando = false;
                });
        },
        /** Primer mensaje legible de una respuesta de error (validación 422 incluida). */
        mensajeDe(error, porDefecto) {
            const cuerpo = error.response && error.response.data;
            if (!cuerpo) return porDefecto;
            if (cuerpo.data && typeof cuerpo.data === "object") {
                const primero = Object.values(cuerpo.data).flat()[0];
                if (primero) return primero;
            }
            return cuerpo.message || porDefecto;
        },
    },
    created() {
        this.cargar();
        this.cargarOpciones();
    },
}
</script>
